import request from "./http";
import qs from 'qs'

//查询看板
export function getBIList(params) {
    return request({
        url: "/BI/find/list",
        method: "get",
        params
      
    });
}
//保存看板
export function saveBI(params) {
    return request({
        url: "/BI/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}


// *能耗分析模型->删除能耗分析模型
//  id id
export function deleteBI(params) {
    return request({
        url: "/BI/delete",
        method: "delete",
        params
    });
}

//预览数据
export function previewData(params) {
    return request({
        url: "/BI/load/data",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}



// 	 * 启用-禁用
//  dateStatus 状态:【ENABLE】-启用,【DISABLE】-禁用,可用值:ENABLE,DISABLE
//  id  看板id

export function BiStatus(params) {
    return request({
        url: "/BI/status",
        method: "put",
        params
    });
}



// 	 * 绑定
//  userId 用户id
//  id  看板id

export function bindingUser(params) {
    return request({
        url: "/BI/binding/user",
        method: "put",
        params
    });
}